import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-reply-dynamic-variables",
  templateUrl: "./reply-dynamic-variables.component.html",
  styleUrls: ["./reply-dynamic-variables.component.scss"],
})
export class ReplyDynamicVariablesComponent implements OnInit {
  @Input() i: number;
  @Input() isValidFormSubmitted: boolean = true;
  @Input() predefinedVariables: any[] = [];
  restrictedVariables: string[] = [
    "{{customer_name}}",
    "{{customer}}",
    "{{name}}",
    "{{username}}",
  ];
  private _selectedTemplate;

  @Input("selectedTemplate")
  set selectedTemplate(value) {
    this._selectedTemplate = value;
  }
  get selectedTemplate() {
    return this._selectedTemplate;
  }
  @Input() dynamicVariables: { [x: string]: { label: string; value: string } } =
    {};
  @Output() public getPreviewContent = new EventEmitter<string>();
  private _content: string;
  @Input()
  set content(value) {
    this._content = value;
  }

  get content() {
    return this._content;
  }
  objectKeys = Object.keys;
  constructor() {}

  ngOnInit() {}
  isFieldDisabled(variable) {
    let isFieldDisabled = variable?.value?.isEditable == false;
    return {
      isFieldDisabled: isFieldDisabled,
    };
  }
  getPlaceHolderText(variable) {
    let placeHolderText = this.isFieldDisabled(variable)?.isFieldDisabled
      ? `${variable?.value?.label} - Cannot Edit`
      : `Enter Value for ${variable?.value?.label}`;
    return placeHolderText;
  }
  private getPredefinedVariable(label: string): {
    value: string;
    isEditable: boolean;
  } {
    let predefinedVariable = this.predefinedVariables.find(
      (e) => e.label == label
    );
    return {
      value: predefinedVariable?.value || "",
      isEditable:
        predefinedVariable !== undefined
          ? predefinedVariable?.is_editable
          : true,
    };
  }

  private templateVariable(label: string) {
    if (this.selectedTemplate !== null) {
      let templateVariable = this.selectedTemplate?.dynamic_variables?.find(
        (e) => {
          return e.variable_name == label;
        }
      );
      return templateVariable;
    }
  }
  private isTemplateVariable(label: string) {
    return this.templateVariable(label);
  }
  private templateVariableArrayLength() {
    let templateVariable: any[] = this.selectedTemplate?.dynamic_variables;
    return templateVariable?.length;
  }
  private getTemplateVariable(label: string): {
    value: string;
    isEditable: boolean;
  } {
    let templateVariable = this.templateVariable(label);
    return {
      value: templateVariable?.variable_value || "",
      isEditable: templateVariable?.is_editable || true,
    };
  }
  private getTrimmedVariables(
    dynamicVariablesMatch: string[],
    previewContent: string = null
  ) {
    const curlyBracesTextReg = /{{(.*?)}}/;
    let newPreviewContent: string = previewContent;
    let trimmedVariables = dynamicVariablesMatch.map((variable) => {
      let newVariable = variable.match(curlyBracesTextReg)[1];
      let trimmedLabel = `{{${newVariable.trim()}}}`;
      if (newPreviewContent !== null) {
        newPreviewContent = newPreviewContent.replace(variable, trimmedLabel);
      }
      return trimmedLabel;
    });
    return { trimmedVariables, newPreviewContent };
  }
  public setDynamicVariables(contentValue: string) {
    const curlyBracesReg = /{{(.*?)}}/gi;
    let dynamicVariablesMatch: string[] =
      contentValue.match(curlyBracesReg) || [];
    let { trimmedVariables } = this.getTrimmedVariables(dynamicVariablesMatch);

    if (trimmedVariables.length) {
      let dynamicVariables = trimmedVariables.reduce((variables, label) => {
        let dynamicObj = this.dynamicVariables[label];
        if (dynamicObj) {
          var [value, isEditable] = [
            dynamicObj["value"],
            dynamicObj["isEditable"],
          ];
        } else {
          var { value, isEditable } = this.getPredefinedVariable(label);
        }

        if (this.isTemplateVariable(label) !== undefined) {
          var { value } = this.getTemplateVariable(label);
        }

        return {
          ...variables,
          [label]: {
            label,
            value,
            isEditable,
          },
        };
      }, {});
      this.dynamicVariables = { ...dynamicVariables };
    } else {
      this.emptyDynamicVariable();
    }
    this.getPreviewContent.emit(this.previewContent(contentValue));
    return this.dynamicVariables;
  }
  onInput() {
    this.updatePreview();
  }
  updatePreview() {
    this.getPreviewContent.emit(this.previewContent(this.content));
  }
  emptyDynamicVariable() {
    this.dynamicVariables = {};
  }
  private filterVariables(isPayload: boolean) {
    const curlyBracesTextReg = /{{(.*?)}}/;
    let dynamicVariables = {};
    let label: string;
    for (const key in this.dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(this.dynamicVariables, key)) {
        const variable = this.dynamicVariables[key];
        if (isPayload) {
          label = variable["label"].match(curlyBracesTextReg)[1];
        } else {
          label = variable["label"];
        }
        let value: string = variable["value"];
        if (label && value) {
          dynamicVariables[label] = value.trim();
        }
      }
    }
    return dynamicVariables;
  }

  createDynamicVariablePayload() {
    let dynamicVariables = this.filterVariables(true);
    return { dynamic_variables: dynamicVariables };
  }

  isInValidDynamicVariable() {
    let isValueInvalid = false;
    let islabelInvalid = false;
    const curlyBracesTextReg = /{{(.*?)}}/;

    for (const key in this.dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(this.dynamicVariables, key)) {
        const variable = this.dynamicVariables[key];
        if (variable["value"] == "" && variable["isEditable"]) {
          isValueInvalid = true;
        }
        let label = variable["label"].match(curlyBracesTextReg)[1];
        label = label?.trim();
        if (label == "") {
          islabelInvalid = true;
        }
      }
    }
    const invalidDetails = {
      value: isValueInvalid,
      label: islabelInvalid,
    };
    return invalidDetails;
  }

  private isVariableChanged(dynamicVariables: { [x: string]: any }) {
    let isUpdate = false;
    for (const key in dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(dynamicVariables, key)) {
        const label = key;
        const variableValue = dynamicVariables[key];
        let isTemplateVariable = this.isTemplateVariable(label) !== undefined;
        if (isTemplateVariable) {
          var value = this.getTemplateVariable(label)?.value;
          if (variableValue !== value) {
            isUpdate = true;
          }
        }
      }
    }
    return isUpdate;
  }
  isUpdateDynamicVariable() {
    let isUpdate = false;
    let dynamicVariables = this.filterVariables(false);
    if (this.selectedTemplate !== null) {
      if (
        this.templateVariableArrayLength() !==
          this.objectKeys(dynamicVariables).length ||
        this.isVariableChanged(dynamicVariables)
      ) {
        isUpdate = true;
      }
    }
    return isUpdate;
  }
  private previewDynamicValue(variable: string) {
    let variableValue = this.dynamicVariables[variable]["value"];
    return variableValue || variable;
  }
  public previewContent(contentValue: string) {
    const curlyBracesReg = /{{(.*?)}}/gi;
    let dynamicVariablesMatch: string[] =
      contentValue.match(curlyBracesReg) || [];
    let { trimmedVariables, newPreviewContent } = this.getTrimmedVariables(
      dynamicVariablesMatch,
      contentValue
    );
    trimmedVariables.forEach((variable) => {
      newPreviewContent = newPreviewContent.replace(
        variable,
        this.previewDynamicValue(variable)
      );
    });
    return newPreviewContent;
  }
}
